import {UILobbyTableController} from './UILobbyTableController.ts'
import {type NetworkEnums} from '../../../../../shared/GameEnums.ts'
import {notificationController} from '../../EntryShared.ts'
import {LobbyImage} from '@colonist/types'
import {setElementOnClick} from '../../ui_utils/DomUtils.ts'
import {createGloballyExclusiveHandler} from '../../ui_utils/ClientUtils.ts'
import {audioManager, AudioType} from '../../Sound.ts'
import {ClientUserState} from '../../ClientUserState.ts'
import {SocketLobbySend} from '../../socket/SocketLobbySend.ts'
import {RoomType} from '@colonist/lobby-types'
import {ViewPopupInput} from '../../ui_popup/ViewPopupInput.ts'

export class UILobbyController {
    readonly tableController: UILobbyTableController

    private readonly lobbyContainerDiv: HTMLDivElement
    protected readonly createRoomButton: HTMLDivElement | undefined
    readonly joinRoomButton: HTMLDivElement

    constructor() {
        this.tableController = new UILobbyTableController()

        this.lobbyContainerDiv = document.getElementById('scene_lobby_mid') as HTMLDivElement
        this.createRoomButton = document.getElementById('m-lobby-create-room-btn') as HTMLDivElement
        this.joinRoomButton = document.getElementById('m-lobby-join-room-btn') as HTMLDivElement

        this.setupButtonHandlers()
    }

    private setupButtonHandlers() {
        if(this.createRoomButton) {
            setElementOnClick(this.createRoomButton, createGloballyExclusiveHandler(async() => {
                audioManager.play(AudioType.JoinRoom)
                await ClientUserState.requireUser()
                SocketLobbySend.clickedCreateRoom(RoomType.Standard)
            }))
        }
        setElementOnClick(this.joinRoomButton, createGloballyExclusiveHandler(() => {
            this.openJoinRoomPopup()
        }))
    }

    // eslint-disable-next-line class-methods-use-this
    protected async handleJoinRoom(roomId: string) {
        await SocketLobbySend.accessGameFromLink(roomId)
    }

    protected openJoinRoomPopup() {
        const popup = new ViewPopupInput({key: 'strings:homePage.lobbyPage.popups.enterRoomID.title'},
            {key: 'strings:homePage.lobbyPage.popups.enterRoomID.body'},
            async(roomId: string) => await this.handleJoinRoom(roomId.trim().toLocaleLowerCase()),
            () => undefined,
            true)
        popup.setLengthLimits(1, 10)
        popup.show()
    }

    hide() {
        this.lobbyContainerDiv.style.display = 'none'
        this.tableController.hide()
    }

    show() {
        this.lobbyContainerDiv.style.display = 'flex'

        this.tableController.show()
    }

    updateRoomList(data: NetworkEnums.RoomListUpdateData) {
        this.tableController.updateRoomList(data)
    }

    onGotKicked(roomId: string, canRejoin: boolean) {
        notificationController.showNotification(LobbyImage.Lightning, {key: 'strings:roomPage.notifications.youWereKickedFromRoom'})
        this.tableController.onGotKicked(roomId, canRejoin)
    }
}
